import { SecurityAccessFeaturesEnum } from 'bff';
import { FeatureToggleRoute } from 'modules/app/components/atoms/feature-flags/useFeature';
import { RouteGuard } from 'components/atoms/route-guard/RouteGuard';
import { RouteBoundary } from 'components/organisms/route-boundary/RouteBoundary';
import { NotFound } from 'modules/app/components/pages/not-found/NotFound';
import { RouteObject } from 'react-router-dom';
import Tracking from 'modules/case-tracking/components/pages/tracking/Tracking';
import Instruction from 'modules/case-tracking/components/pages/tracking/Instruction';
import { routes } from 'routes/route-paths';

export const caseTrackingRoutes: RouteObject[] = [
  {
    path: '',
    index: true,
    element: (
      <FeatureToggleRoute
        component={
          <RouteGuard
            component={
              <RouteBoundary>
                <Tracking />
              </RouteBoundary>
            }
            features={[SecurityAccessFeaturesEnum.Tracking]}
          />
        }
        fallback={<NotFound />}
        feature='showCaseTracking'
      />
    )
  },
  {
    path: routes.caseTrackingRoutes.instruction,
    element: (
      <FeatureToggleRoute
        component={
          <RouteGuard
            component={
              <RouteBoundary>
                <Instruction />
              </RouteBoundary>
            }
            features={[SecurityAccessFeaturesEnum.Tracking]}
          />
        }
        fallback={<NotFound />}
        feature='showCaseTracking'
      />
    )
  }
];
